<template>
  <Chart :options="chartOptions" />
</template>

<script>
import { Chart, Highcharts } from '../Highcharts';
import themeColors from '../../theme/apim-chart-colors';

const defaultOptions = {
  chart: {
    backgroundColor: null,
    borderWidth: 0,
    type: 'line',
    margin: [2, 0, 2, 0],
    height: 41,
    styledMode: true,
  },
  title: {
    text: '',
  },
  credits: {
    enabled: false,
  },
  xAxis: {
    type: 'datetime',
    labels: {
      enabled: false,
    },
    title: {
      text: null,
    },
    startOnTick: false,
    endOnTick: false,
    tickPositions: [],
  },
  yAxis: {
    endOnTick: false,
    startOnTick: false,
    labels: {
      enabled: false,
    },
    title: {
      text: null,
    },
    tickPositions: [4, 6, 8],
    min: 0,
    max: 10,
  },
  legend: {
    enabled: false,
  },
  tooltip: {
    outside: true,
    shared: true,
    valueDecimals: 2,
  },
  plotOptions: {
    series: {
      name: 'CASC Score',
      valueDecimals: 2,
      lineWidth: 2,
      shadow: false,
      states: {
        hover: {
          lineWidth: 3,
        },
      },
      marker: {
        radius: 2,
        states: {
          hover: {
            radius: 3,
          },
        },
      },
    },
  },
  exporting: {
    enabled: false,
  },
};

export default {
  name: 'SparkLine',
  components: {
    Chart,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  computed: {
    chartOptions() {
      return Highcharts.merge(defaultOptions, {
        series: [
          {
            cursor: 'pointer',
            data: this.data,
            point: {
              events: {
                click: (e) => {
                  this.$emit('click-point', e);
                },
              },
            },
          },
        ],
      });
    },
  },
  ...themeColors,
};
</script>
